import { AxiosService } from './axiosService';

export class DataInspectorService extends AxiosService {
    async getGroups() {
        try {
            const { data } = await this.axios.get("/dataInspector/group");
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getBuildingsByGroupId(groupId, showStale) {
        try {
            const { data } = await this.axios.get(`/dataInspector/buildings/${groupId}`, {
                params: {
                    showStale
                }
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getEquipmentPoints(body) {
        try {
            const { data } = await this.axios.post('/dataInspector/equipment/point/', body);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getEquipmentFunctions(body) {
        try {
            const { data } = await this.axios.post(`/dataInspector/equipment/function/`, body);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getEquipmentByBuildingId(body) {
        try {
            const { data } = await this.axios.post(`/dataInspector/equipment/`, body);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getEquipmentByGroupId(body) {
        try {
            const { data } = await this.axios.post(`/dataInspector/equipment/byGroup/`, body);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async postDataInspectorQuery(query) {
        try {
            const { data } = await this.axios.post(`/reports/datatable`, query);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async postDataInspectorExportQuery(query) {
        try {
            const { data } = await this.axios.post(`/reports/dataexport`, query);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async postDataInspectorExportFunctionQuery(query) {
        try {
            const { data } = await this.axios.post(`/reports/dataexport/functions`, query);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async updatePointData(query) {
        try {
            const { data } = await this.axios.put(`/updatePointData`, query);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getFunctionDiagnostics(query) {
        try {
            const { data } = await this.axios.post(`/GetFunctionDiagnostics`, query);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async getNumericPoints(equipmentId, includeChildren) {
        try {
            const { data } = await this.axios.post('/dataInspector/equipment/numericPoints/', {equipmentId, includeChildren});
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async createEquipmentNumericPoint(equipmentPointId, effectiveDate, value) {
        try {
            const { data } = await this.axios.post('/dataInspector/equipment/numericPoint/', {
                equipmentPointId,
                effectiveDate,
                value
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async editEquipmentNumericPoint(id, effectiveDate, value) {
        try {
            const { data } = await this.axios.put('/dataInspector/equipment/numericPoint', {
                id,
                effectiveDate,
                value
            });
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }

    async deleteEquipmentNumericPoint(id) {
        try {
            const { data } = await this.axios.delete(`/dataInspector/equipment/numericPoint/${id}`);
            return data;
        } catch (e) {
            // if the status code is a 401 we do NOT want to throw
            if ((e)?.response?.status !== 401) {
                throw e;
            }
        }
        return null;
    }
}

export const dataInspectorService = new DataInspectorService();